"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCheckbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var Input_1 = require("./Input");
var styles_1 = require("../../styles");
var DivForCheckbox = (0, styled_components_1.default)(Input_1.Div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n\n  ", "\n"], ["\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var disable = _a.disable;
    return disable && "\n    pointer-events: none;\n    user-select: none;\n  ";
});
var Input = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n  user-select: none;\n"], ["\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n  user-select: none;\n"])));
var TickBox = styled_components_1.default.figure(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  display: flex;\n  height: 16px;\n  justify-content: center;\n  margin: 0 10px 0 0;\n  transition: 150ms background-color linear, 150ms border-color linear;\n  width: 16px;\n\n  img {\n    opacity: ", ";\n    transition: 150ms opacity 100ms linear;\n    width: 10px;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  display: flex;\n  height: 16px;\n  justify-content: center;\n  margin: 0 10px 0 0;\n  transition: 150ms background-color linear, 150ms border-color linear;\n  width: 16px;\n\n  img {\n    opacity: ", ";\n    transition: 150ms opacity 100ms linear;\n    width: 10px;\n  }\n"])), function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked ? theme.colors.orange : 'transparent';
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked ? theme.colors.orange : (0, styles_1.hex2Rgba)(theme.colors.input_black, .2);
}, function (_a) {
    var checked = _a.checked;
    return checked ? 1 : 0;
});
var Label = (0, styled_components_1.default)(framer_motion_1.motion.label)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: flex-start;\n  color: ", ";\n  cursor: pointer!important;\n  display: flex;\n\tfont-size: ", ";\n  font-weight: normal;\n  letter-spacing: 0;\n  line-height: ", ";\n  position: static;\n  transition: color 300ms ", ";\n  user-select: none;\n\n  ", "\n\n  span {\n    opacity: .4;\n  }\n\n  &:hover {\n    span {\n      opacity: ", ";\n    }\n\n    ", " {\n      border-color: ", ";\n    }\n  }\n\n"], ["\n  align-items: flex-start;\n  color: ", ";\n  cursor: pointer!important;\n  display: flex;\n\tfont-size: ", ";\n  font-weight: normal;\n  letter-spacing: 0;\n  line-height: ", ";\n  position: static;\n  transition: color 300ms ", ";\n  user-select: none;\n\n  ", "\n\n  span {\n    opacity: .4;\n  }\n\n  &:hover {\n    span {\n      opacity: ", ";\n    }\n\n    ", " {\n      border-color: ", ";\n    }\n  }\n\n"])), function (_a) {
    var colors = _a.theme.colors, active = _a.active, textColor = _a.textColor, error = _a.error;
    return error ? colors.input_error : active ? colors["input_text_".concat(textColor)] : colors.input_black;
}, (0, styles_1.getRelative)(18, 'mobile'), (0, styles_1.getRelative)(25, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, styles_1.mq.greaterThan('tablet')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, styles_1.getRelative)(18, 'desktop'), (0, styles_1.getRelative)(25, 'desktop')), function (_a) {
    var isDirty = _a.isDirty;
    return isDirty ? '.4' : '1';
}, TickBox, function (_a) {
    var theme = _a.theme;
    return theme.colors.orange;
});
var Span = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: 1px;\n  transition: 300ms opacity cubic-bezier(.25, .1, .25, 1);\n"], ["\n  margin-top: 1px;\n  transition: 300ms opacity cubic-bezier(.25, .1, .25, 1);\n"])));
exports.InputCheckbox = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
    var name = _a.name, _b = _a.reset, reset = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? 'Label' : _c, _d = _a.initialInputState, initialInputState = _d === void 0 ? Input_1.DEFAULT_INPUT_STATE : _d, _e = _a.initialChecked, initialChecked = _e === void 0 ? false : _e, _f = _a.onChange, onChange = _f === void 0 ? null : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.error, error = _h === void 0 ? false : _h, _j = _a.className, className = _j === void 0 ? '' : _j, _k = _a.onFocus, onFocus = _k === void 0 ? null : _k, _l = _a.errorMessage, errorMessage = _l === void 0 ? 'There was an error' : _l, _m = _a.once, once = _m === void 0 ? false : _m, _o = _a.textColor, textColor = _o === void 0 ? 'dark' : _o;
    var _p = __read((0, react_1.useState)(initialChecked), 2), checked = _p[0], setChecked = _p[1];
    var _q = __read((0, react_1.useState)(initialInputState), 2), inputState = _q[0], setState = _q[1];
    var _r = __read((0, react_1.useState)(false), 2), isDirty = _r[0], setDirty = _r[1];
    var handleChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        if (!isDirty) {
            onChange && onChange(checked, target.checked);
            setChecked(target.checked);
            if (target.checked && once) {
                setDirty(true);
            }
        }
    }, [onChange]);
    var handleStateChange = (0, react_1.useCallback)(function (keys, values) { return function () {
        var _a, _b;
        var newState = __assign({}, inputState);
        if (typeof keys === 'string') {
            newState = __assign(__assign({}, newState), (_a = {}, _a[keys] = values, _a));
        }
        else {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var value = values[i];
                newState = __assign(__assign({}, newState), (_b = {}, _b[key] = value, _b));
            }
        }
        setState(newState);
    }; }, [inputState]);
    var handleInputFocus = (0, react_1.useCallback)(function () {
        onFocus && onFocus();
        handleStateChange('focus', true)();
    }, []);
    var handleOnBlur = (0, react_1.useCallback)(function () {
        handleStateChange('focus', false)();
        handleStateChange('activated', false)();
    }, []);
    (0, react_1.useEffect)(function () {
        if (reset) {
            setChecked(false);
            handleStateChange('activated', false)();
        }
    }, [reset]);
    (0, react_1.useEffect)(function () {
        setChecked(initialChecked);
        handleStateChange('activated', initialChecked)();
        return function () { return handleStateChange('activated', false)(); };
    }, [initialChecked]);
    return ((0, jsx_runtime_1.jsxs)(DivForCheckbox, __assign({ className: className, disable: disabled || isDirty, onMouseEnter: handleStateChange('hover', true), onMouseLeave: handleStateChange('hover', false) }, { children: [(0, jsx_runtime_1.jsxs)(Label, __assign({ error: error, textColor: textColor }, { children: [(0, jsx_runtime_1.jsx)(Input, { name: name, checked: checked, ref: ref, autoComplete: 'off', type: 'checkbox', disabled: disabled || isDirty, onFocus: handleInputFocus, onBlur: handleOnBlur, onChange: handleChange }), (0, jsx_runtime_1.jsx)(TickBox, __assign({ checked: checked }, { children: (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/i--tick.svg', alt: 'Icon tick', width: '9', height: '9' }) })), (0, jsx_runtime_1.jsx)(Span, { className: 'label__text', dangerouslySetInnerHTML: { __html: label } })] })), (0, jsx_runtime_1.jsx)(Input_1.P, __assign({ error: error, transition: Input_1.transition, variants: Input_1.variantsError, animate: error ? 'active' : 'inactive' }, { children: errorMessage }))] })));
}));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
